<template>
    <div
        v-if="attr"
        class="el-ext__attr"
        :class="{'error': errorMsg}"
        style="position: relative;"
    >
        <!-- 当 mode 是 edit 则这里是修改 -->

        <el-form-item
            v-if="mode==='edit'"
            :required="attr.requireFlag"
        >
            <template
                v-if="showFormItemLabel"
                slot="label"
            >
                <span v-if="elForm">
                    <span>{{ attr.attrName }}{{ elForm.labelSuffix }}</span>
                    <slot
                        name="attrLabelSuffix"
                        :attr="attr"
                    ></slot>
                </span>
            </template>

            <div v-if="attr.tip || attr.externalDesc">
                <!-- 如果有tip(填写说明)显示el-tooltip -->
                <el-tooltip
                    popper-class="attr-popper"
                    placement="top"
                    effect="light"
                    :content="attr.externalDesc || attr.tip"
                >
                    <xx-permission
                        v-if="attr.code === 'exceedRatio'"
                        style="width: 100%;"
                        code="mall.fe.pc_69cda048c56a131908bdc8f158dd9167"
                        dev-code="mall.fe.pc_fe803f21fc1e33523ef30de5a1ff894a"
                    >
                        <template
                            slot="custom"
                            slot-scope="scope"
                        >
                            <el-input
                                :value="sv2v(attr.selectedValues, attr.valueType)"
                                :disabled="disabled || !scope.hasPermission"
                                @change="changeValue"
                            />
                        </template>
                    </xx-permission>
                    <div
                        v-else
                        style="display: inline-block; width:460px"
                    >
                        <el-input
                            v-if="attr.valueType===extValueTypeMap.NUMBER"
                            :disabled="disabled"
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            :style="attr.categoryExtUnitNames && attr.categoryExtUnitNames.length ? 'width:300px' :''"
                            @change="((val)=>{changeValue(val,sv2v(attr.selectedValues, attr.valueType,'unit'))})"
                        />
                        <div
                            v-if="attr.valueType===extValueTypeMap.NUMBER && attr.categoryExtUnitNames && attr.categoryExtUnitNames.length"
                            style="display: inline-block;"
                        >
                            <mc-select
                                :value="sv2v(attr.selectedValues, attr.valueType,'unit')"
                                :source="attr.categoryExtUnitNames.map((item)=>({label: item, value: item}))"
                                :scroll-step="{size: 20}"
                                clearable
                                :disabled="isDnaAttr ? disabled : false"
                                @change="((val)=>{changeExtItemAttr(sv2v(attr.selectedValues, attr.valueType),val,'unit')})"
                            />
                        </div>
                        <el-input
                            v-if="attr.valueType===extValueTypeMap.TEXT && !inputTypeIsTextarea"
                            :disabled="disabled"
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            @change="changeValue"
                        />
                        <el-input
                            v-if="attr.valueType===extValueTypeMap.TEXT && inputTypeIsTextarea"
                            :disabled="disabled"
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            type="textarea"
                            :rows="4"
                            @change="changeValue"
                        />
                        <xx-select
                            v-if="attr.valueType===extValueTypeMap.RADIO"
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            :list="options"
                            filterable
                            use-scroll
                            label-key="value"
                            value-key="id"
                            :clearable="canClear"
                            :disabled="disabled"
                            :disabled-ids="disabledIds"
                            @change="changeValue"
                        />
                        <el-select
                            v-if="attr.valueType===extValueTypeMap.MULTI"
                            :disabled="disabled"
                            multiple
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            size="small"
                            @change="changeValue"
                        >
                            <el-option
                                v-for="(option,index) in options"
                                :key="index"
                                :label="option.value"
                                :value="option.id"
                                :disabled="ignoreValid ? false : !option.valid"
                            />
                        </el-select>
                    </div>
                </el-tooltip>
                <FocusTag v-if="focusedMarkingList.includes(+attr.attrId)" />
                <slot
                    name="tip"
                ></slot>
            </div>
            <!-- 没有tip(填写说明) -->
            <div
                v-else
            >
                <xx-permission
                    v-if="attr.code === 'exceedRatio'"
                    style="width: 100%;"
                    code="mall.fe.pc_69cda048c56a131908bdc8f158dd9167"
                    dev-code="mall.fe.pc_fe803f21fc1e33523ef30de5a1ff894a"
                >
                    <template
                        slot="custom"
                        slot-scope="scope"
                    >
                        <el-input
                            :value="sv2v(attr.selectedValues, attr.valueType)"
                            :disabled="disabled || !scope.hasPermission"
                            @change="changeValue"
                        />
                    </template>
                </xx-permission>
                <div
                    v-else
                    style="display: inline-block; width:460px"
                >
                    <el-input
                        v-if="attr.valueType===extValueTypeMap.NUMBER"
                        :disabled="disabled"
                        :value="sv2v(attr.selectedValues, attr.valueType)"
                        :style="attr.categoryExtUnitNames && attr.categoryExtUnitNames.length ? 'width:300px' :''"
                        @change="((val)=>{changeValue(val,sv2v(attr.selectedValues, attr.valueType,'unit'))})"
                    />
                    <div
                        v-if="attr.valueType===extValueTypeMap.NUMBER && attr.categoryExtUnitNames && attr.categoryExtUnitNames.length"
                        style="display: inline-block;"
                    >
                        <mc-select
                            :value="sv2v(attr.selectedValues, attr.valueType,'unit')"
                            :source="attr.categoryExtUnitNames.map((item)=>({label: item, value: item}))"
                            :scroll-step="{size: 20}"
                            clearable
                            :disabled="isDnaAttr ? disabled : false"
                            @change="((val)=>{changeExtItemAttr(sv2v(attr.selectedValues, attr.valueType),val)})"
                        />
                    </div>
                    <el-input
                        v-if="attr.valueType===extValueTypeMap.TEXT && !inputTypeIsTextarea"
                        :disabled="disabled"
                        :value="sv2v(attr.selectedValues, attr.valueType)"
                        @change="changeValue"
                    />
                    <el-input
                        v-if="attr.valueType===extValueTypeMap.TEXT && inputTypeIsTextarea"
                        :disabled="disabled"
                        :value="sv2v(attr.selectedValues, attr.valueType)"
                        type="textarea"
                        :rows="4"
                        @change="changeValue"
                    />
                    <xx-select
                        v-if="attr.valueType===extValueTypeMap.RADIO"
                        :value="sv2v(attr.selectedValues, attr.valueType)"
                        :list="options"
                        filterable
                        use-scroll
                        label-key="value"
                        value-key="id"
                        :clearable="canClear"
                        :disabled="disabled"
                        :disabled-ids="disabledIds"
                        @change="changeValue"
                    />
                    <el-select
                        v-if="attr.valueType===extValueTypeMap.MULTI"
                        :disabled="disabled"
                        multiple
                        :value="sv2v(attr.selectedValues, attr.valueType)"
                        size="small"
                        @change="changeValue"
                    >
                        <el-option
                            v-for="(option,index) in options"
                            :key="index"
                            :label="option.value"
                            :value="option.id"
                            :disabled="ignoreValid ? false : !option.valid"
                        />
                    </el-select>
                </div>
                <FocusTag v-if="focusedMarkingList.includes(+attr.attrId)" />
                <slot
                    name="tip"
                ></slot>
            </div>
            <!-- 扩展属性的推荐值 -->
            <template
                v-if="innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId)
                    && !isEmpty(innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).selectedValues)"
            >
                <mc-tag
                    theme="green"
                    type="pure"
                >
                    推荐
                </mc-tag>
                <!-- 多选 -->
                <span v-if="innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).valueType === extValueTypeMap.MULTI">
                    {{ innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).selectedValues.map((child) => child.value).join(',') }}
                </span>
                <!-- 数字、文本、单选 -->
                <span v-if="[extValueTypeMap.NUMBER, extValueTypeMap.TEXT, extValueTypeMap.RADIO].includes(innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).valueType)">
                    {{ innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).selectedValues[0].value + (innerRecommendAttrList.find((item) => item.extAttrId === attr.attrId).selectedValues[0].unit || '') }}
                </span>
                <mc-button
                    v-if="!disabled"
                    type="text"
                    size="small"
                    @click="handleUseRecommendValue"
                >
                    使用推荐
                </mc-button>
            </template>
            <!-- 在详情模式下 -->
            <slot name="attrItemAudit"></slot>
        </el-form-item>
        <el-form-item
            v-else
            :label="attr.attrName"
            :required="attr.requireFlag"
            style="display: inline-block;"
        >
            <el-input
                v-if="attr.valueType===extValueTypeMap.TEXT && inputTypeIsTextarea"
                :value="sv2v(attr.selectedValues, attr.valueType)"
                disabled
                type="textarea"
                :rows="4"
                @change="changeValue"
            />
            <span v-else>
                <mc-tooltip
                    v-if="attr.externalDesc || attr.tip"
                    :content="attr.externalDesc || attr.tip"
                    placement="top"
                    theme="light"
                >
                    <span style="cursor: pointer;">{{ showLabel() }}</span>
                </mc-tooltip>
                <span v-else>
                    <mc-tooltip
                        v-if="attr.externalDesc || attr.tip"
                        :content="attr.externalDesc || attr.tip"
                        placement="top"
                        theme="light"
                    >
                        <span style="cursor: pointer;">{{ showLabel() }}</span>
                    </mc-tooltip>
                    <span v-else>{{ showLabel() }}</span>
                </span>
            </span>
            <span
                v-if="isShowRecommend"
                style="display: inline-block;"
            >
                <div class="recommend">
                    算法推荐：{{ disparityRecommendName }}
                    <mc-tag
                        theme="red"
                        type="pure"
                        style="margin-left:8px"
                    >
                        不一致
                    </mc-tag>
                </div>
            </span>

            <FocusTag v-if="focusedMarkingList.includes(+attr.attrId)" />

            <NutrientContentTip
                v-if="extAttrTip[attr.attrId] && extAttrTip[attr.attrId].tip"
                :html-content="extAttrTip[attr.attrId].tip"
            />
            <!-- 在详情模式下 -->
            <slot name="attrItemAudit"></slot>
        </el-form-item>

        <div
            v-if="showValueImage && valueImageList.length "
            :class="mode==='edit' ? 'edit_image_icon' : 'image_icon'"
        >
            <mc-popover
                trigger="hover"
                placement="top"
            >
                <i class="mtdicon-info-circle-o"></i>
                <div
                    slot="content"
                >
                    <mc-image
                        style="width: 100px; height: 100px"
                        :src="valueImageList[0]"
                        :preview-url-list="valueImageList"
                    />
                </div>
            </mc-popover>
        </div>
    </div>
</template>

<script>
import { extValueTypeMap, extRequiredTypeMap } from 'utils/dataMap';
import emitter from 'utils/emitter';
import { isEmpty } from '@lsfe/tools';
import FocusTag from '../pages/product/components/FocusTag';
import NutrientContentTip from '../pages/product/components/NutrientContentTip';

// const isEmpty = (value) => Array.isArray(value) && !value.length;
const keysCache = [];

export default {
    componentName: 'validate-input',
    inject: {
        elForm: {
            default: null,
        },
    },
    components: {
        FocusTag,
        NutrientContentTip,
    },
    mixins: [emitter],
    props: {
        attr: {
            type: Object,
        },
        mode: {
            type: [String],
            required: true,
        },
        inputTypeIsTextarea: {
            type: Boolean,
            deafault: false,
        },
        emptyText: {
            type: String,
            default: '',
        },
        canClear: {
            type: Boolean,
            default: true,
        },
        lockFields: {
            type: Array,
            default: () => ([]),
        },
        // 是否忽略无效option
        ignoreValid: {
            type: Boolean,
            default: false,
        },
        defaultDisabled: {
            type: Boolean,
            default: false,
        },
        // 唯一标识，保证属性key不重复，用于缓存
        uniqueFlag: {
            type: [String, Number],
            default: '',
        },
        showFormItemLabel: {
            type: Boolean,
            default: true,
        },
        // 是否显示拓展属性选中值的说明图片
        showValueImage: {
            type: Boolean,
            default: false,
        },
        recommendAttrList: {
            type: Array,
            default: () => ([]),
        },
        // c端展示重点属性
        focusedMarkingList: {
            type: Array,
            default: () => ([]),
        },
        // 是否为DNA属性组件传入，控制单位下拉禁用逻辑
        isDnaAttr: {
            type: Boolean,
            default: false,
        },
        // 扩展属性提示信息
        extAttrTip: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            extValueTypeMap,
            extRequiredTypeMap,
            errorMsg: '',
            isShowToast: true,
            maxLen: 300,
            innerRecommendAttrList: this.recommendAttrList,
        };
    },
    computed: {
        disabled() {
            const {
                attrId, attrName, selectedValues, requireFlag,
            } = this.attr;
            const key = `${this.uniqueFlag}-${attrId}-${attrName}`;
            // 兜底必填但没值的场景，可以编辑
            if (requireFlag && this.isEmpty(selectedValues) && !keysCache.includes(key)) keysCache.push(key);
            if (keysCache.includes(key)) return false;
            // 锁字段逻辑
            return this.lockFields.includes(`${this.attr.attrId}`) || this.defaultDisabled;
        },

        options() {
            let options = [];
            if (
                (this.attr.valueType === this.extValueTypeMap.RADIO || this.attr.valueType === this.extValueTypeMap.MULTI) && !this.ignoreValid
            ) {
                options = this.attr.selectValues.filter((el) => {
                    // option is passed which one's valid is false
                    const index = this.attr.selectedValues.findIndex((e) => `${e.id}` === `${el.id}`);
                    return index > -1 || el.valid;
                });
            } else {
                options = this.attr.selectValues;
            }
            return options;
        },
        value: {
            get() {
                return this.sv2v(this.attr.selectedValues, this.attr.valueType);
            },
        },
        disabledIds() {
            if (this.ignoreValid) return [];
            return this.options.filter((option) => option.valid === false).map((option) => option.id);
        },

        // 拓展属性值说明图片
        valueImageList() {
            // 使用reduce方法，遍历当前选中的值，初始化一个空数组
            const valueImageList = this.attr.selectedValues.reduce((acc, cur) => {
                // 在所有选项中找到当前选中值对应的选项
                const attrValObj = this.attr.selectValues.find((item) => cur.id === item.id);
                // 如果找到的选项有图片URL，则将其添加到数组中
                if (attrValObj && attrValObj.pictureUrl) acc.push(attrValObj.pictureUrl);
                // 返回累积的数组
                return acc;
            }, []);
            // 返回图片URL列表
            return valueImageList;
        },
        // 是否展示算法推荐
        isShowRecommend() {
            const recommend = (this.recommendAttrList || []).find((item) => item.extAttrId === this.attr.attrId);
            if (!recommend) return false;
            const selectedValues = this.attr.selectedValues.map((item) => item.id).sort();
            const recommendSelectedValues = recommend.selectedValues.map((item) => item.id).sort();

            switch (recommend.valueType) {
                case this.extValueTypeMap.RADIO:
                case this.extValueTypeMap.MULTI:
                    return JSON.stringify(selectedValues) !== JSON.stringify(recommendSelectedValues);
                default:
                    return this.attr.selectedValues[0]?.value + (this.attr.selectedValues[0]?.unit || '') !== recommend.selectedValues[0]?.value + (recommend.selectedValues[0]?.unit || '');
            }
        },
        // 算法推荐的名称
        disparityRecommendName() {
            const recommend = (this.recommendAttrList || []).find((item) => item.extAttrId === this.attr.attrId);
            return (recommend?.selectedValues || []).map((item) => item.value).toString();
        },
    },
    watch: {
        errorMsg(val) {
            if (this.isShowToast && val) this.$message.error(`以下信息有误: 1 ) ${val}`);
        },
        recommendAttrList: {
            handler(val) {
                this.innerRecommendAttrList = val;
            },
            deep: true,
        },
    },
    mounted() {
        this.$on('validate', this.broadcastValidate);
    },
    methods: {
        isEmpty,
        sv2v(sv, vt, unit) {
            if (vt === this.extValueTypeMap.MULTI) {
                const v = [];
                sv.forEach((e) => {
                    v.push(e.id);
                });
                return v;
            }
            if (vt === this.extValueTypeMap.RADIO) {
                // return (sv[0] && sv[0].id) || '';
                return sv[0] ? sv[0].id : ''; // 兼容id=0的情况
            }
            if (
                vt === this.extValueTypeMap.NUMBER || vt === this.extValueTypeMap.TEXT
            ) {
                if (unit) return sv[0] && sv[0].unit ? sv[0].unit : '';
                const v = (sv[0] && sv[0].value) || '';
                return v;
            }
            return '';
        },
        v2sv(v, vt, unit) {
            if (vt === this.extValueTypeMap.MULTI) {
                const sv = [];
                v.forEach((e) => {
                    const attr = this.attr.selectValues.find(
                        (item) => +item.id === +e,
                    );
                    const attrValue = (attr && attr.value) || '';
                    if (attrValue) sv.push({ id: e, value: attrValue });
                });
                return sv;
            }
            if (vt === this.extValueTypeMap.RADIO) {
                const attr = this.attr.selectValues.find((item) => +item.id === +v);
                const attrValue = (attr && attr.value) || '';
                const sv = [];
                if (attrValue) sv.push({ id: v, value: attrValue });
                return sv;
            }
            if (vt === this.extValueTypeMap.NUMBER || vt === this.extValueTypeMap.TEXT) {
                const sv = [];
                if (v.trim() || unit) sv.push({ id: 0, value: v.trim(), unit });
                return sv;
            }
            return '--';
        },
        showLabel() {
            const sv = this.attr.selectedValues;
            const vt = this.attr.valueType;

            if (vt === this.extValueTypeMap.MULTI) {
                const rt = [];
                sv.forEach((v) => {
                    rt.push(v.value);
                });
                return rt.join('/') || this.emptyText || '无';
            }
            if (vt === this.extValueTypeMap.RADIO) {
                let rt = '';
                if (sv.length > 0) {
                    rt = sv[0].value;
                }
                return rt || this.emptyText || '空';
            }
            if (vt === this.extValueTypeMap.NUMBER || vt === this.extValueTypeMap.TEXT) {
                let rt = '';
                if (sv.length > 0) {
                    rt = sv[0].value + (sv[0].unit ? sv[0].unit : '');
                }
                return rt || this.emptyText || '空';
            }
            return '--';
        },
        broadcastValidate() {
            const errorMessage = this.valid(this.value, false);
            this.dispatch(
                'validate-form',
                'validate-message',
                errorMessage || '',
            );
        },
        valid(val = this.value, isShowToast = true) {
            this.isShowToast = isShowToast;
            this.errorMsg = '';
            const vt = this.attr.valueType;
            if (typeof val === 'string') val = val.trim();
            if (this.attr.requireFlag) {
                if (val === '' || val.length === 0) {
                    this.errorMsg = `${this.attr.attrName}属性为必填项`;
                } else {
                    if (vt === this.extValueTypeMap.NUMBER) {
                        if (
                            !/(^-?[1-9]\d*(\.\d{1,3})?$)|(^-?0(\.\d{1,3})?$)/.test(
                                val,
                            )
                        ) {
                            this.errorMsg = `${this.attr.attrName}属性必须为数字且最多支持3位小数`;
                        }
                    }
                    if (vt === this.extValueTypeMap.TEXT) {
                        if (val.length > this.maxLen) {
                            this.errorMsg = `${this.attr.attrName}属性长度必须小于${this.maxLen}`;
                        }
                    }
                }
            } else if (val) {
                // 有值才检测
                if (vt === this.extValueTypeMap.NUMBER) {
                    if (val === '') this.errorMsg = '';
                    else if (
                        !/(^-?[1-9]\d*(\.\d{1,3})?$)|(^-?0(\.\d{1,3})?$)/.test(
                            val,
                        )
                    ) {
                        this.errorMsg = `${this.attr.attrName}属性必须为数字且最多支持3位小数`;
                    }
                }
                if (vt === this.extValueTypeMap.TEXT) {
                    if (val === '') this.errorMsg = '';
                    else if (val.length > this.maxLen) {
                        this.errorMsg = `${this.attr.attrName}属性长度必须小于${this.maxLen}`;
                    }
                }
            }
            return this.errorMsg;
        },
        changeValue(val, unit) {
            this.valid(val);
            this.changeExtItemAttr(val, unit);
        },
        changeExtItemAttr(val, unit) {
            this.$emit('changeExtAttr', {
                attrId: this.attr.attrId,
                selectedValues: this.v2sv(val, this.attr.valueType, unit),
            });
        },
        // 使用推荐值，和组件抛出选中值的方式保持一致
        handleUseRecommendValue() {
            // 1.确定推荐值的数据格式：数组 or 字符串、数字
            const valueType = this.innerRecommendAttrList.find((item) => item.extAttrId === this.attr.attrId).valueType;
            let val = '';
            let unit = '';
            if (valueType === this.extValueTypeMap.MULTI) {
                val = this.innerRecommendAttrList.find((item) => item.extAttrId === this.attr.attrId).selectedValues.map((item) => item.id);
            } else if (valueType === this.extValueTypeMap.RADIO) {
                val = this.innerRecommendAttrList.find((item) => item.extAttrId === this.attr.attrId).selectedValues[0]?.id;
            } else {
                val = this.innerRecommendAttrList.find((item) => item.extAttrId === this.attr.attrId).selectedValues[0]?.value;
                unit = this.innerRecommendAttrList.find((item) => item.extAttrId === this.attr.attrId).selectedValues[0]?.unit || '';
            }
            // 2.和组件抛出选中值的方式保持一致，处理数据
            this.changeValue(val, unit);
        },
        getDisabledStatus(attr, value, required) {
            const key = '';
            // 兜底必填但没值的场景
            if (required && this.isEmpty(value) && !keysCache.includes(key)) keysCache.push(key);
            if (keysCache.includes(key)) return false;
            // 锁字段逻辑
            return this.disabled || this.defaultDisabled;
        },
    },
};
</script>

<style lang="scss" scoped>
.el-ext__attr.error {
    .el-form-item__content {
        .el-input {
            input {
                border-color: #ff4949;
            }
        }
    }
}
.el-select__tags-text {
    max-width: 120px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}

.el-ext__attr {
    /deep/ .el-form-item__label {
        word-spacing: -3px;
    }
    /deep/ .el-select {
        width: 100%;
    }
}
.el-icon-info {
    font-size: 13px;
}
.image_icon{
    font-size: 20px;
    display: inline-block;
}
.edit_image_icon{
    font-size: 20px;
    position: absolute;
    top: 0;
    right: -28px;
}
.recommend{
    font-size: 13px;
    margin-left: 30px;
    display: flex;
    align-items: center;
}
</style>

<style>
.attr-popper {
    max-width: 400px;
}
</style>
